"use strict";import{tag as o}from"../custom-tag.js";export{setCustomTemplateLiteralTag}from"../custom-tag.js";export const DownloadIcon=({width:a=24,height:t=24,hidden:e=!1,title:l="Download"}={})=>o`<svg
    xmlns="http://www.w3.org/2000/svg"
    width=${a}
    height=${t}
    viewBox="0 0 36 36"
    aria-hidden=${e?"true":"false"}
    role="img"
    fill="currentColor"
    aria-label=${l}
  >
    <path
      d="M33 24h-2a1 1 0 0 0-1 1v5H6v-5a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h30a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1Z"
    />
    <path
      d="M17.65 26.856a.5.5 0 0 0 .7 0l7.446-7.525a.785.785 0 0 0 .204-.526.8.8 0 0 0-.802-.805H20V3a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v15h-5.198a.8.8 0 0 0-.802.805.785.785 0 0 0 .204.526Z"
    />
  </svg>`;
//# sourceMappingURL=Download.js.map
